import { ICDAuxCheckboxModel } from "./icd-aux-checkbox.model";
import { ICDBaseModel } from "./icd-base.model";

export class ICDEnumModel {
  // must
  public value: string;
  public id: string;
  public label: string;
  public tooltip: string;

  constructor(_value?: any, _label?: string, _enumId?: string, _tooltip?: string) {
    this.value = _value != null ? _value : null;
    this.label = _label != null ? _label : null;
    this.id = _enumId != null ? _enumId : null;
    this.tooltip = _tooltip != null ? _tooltip : null;
  }
}
